import React from 'react';
import { motion } from 'framer-motion';
import { QrCodeIcon, CupSodaIcon, CreditCardIcon, PackageCheckIcon, ArrowRightIcon } from 'lucide-react';
import { useI18n } from '../../lib/i18n';
const steps = [{
  icon: QrCodeIcon,
  title: 'step_scan',
  desc: 'step_scan_d'
}, {
  icon: CupSodaIcon,
  title: 'step_select',
  desc: 'step_select_d'
}, {
  icon: CreditCardIcon,
  title: 'step_pay',
  desc: 'step_pay_d'
}, {
  icon: PackageCheckIcon,
  title: 'step_enjoy',
  desc: 'step_enjoy_d'
}];
export function HowItWorks() {
  const {
    t
  } = useI18n();
  return <section className="mx-auto max-w-container px-4 py-16 sm:px-6 sm:py-20" aria-labelledby="how-title" data-id="element-40" data-mp="3v8v8guy44jn5">
      <h2 id="how-title" className="text-center text-2xl font-bold text-white sm:text-3xl" data-id="element-41" data-mp="41sig6u0gjei">
        {t('how_it_works')}
      </h2>

      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-42" data-mp="1yg33s5becvfj">
        {steps.map((step, i) => <motion.div key={step.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.1
      }} className="glass-card relative flex flex-col items-center p-6 text-center" data-id="element-43" data-mp="1v0ff5zw0imp4" data-mpi={i}>
            <span className="absolute right-4 top-4 text-sm font-bold text-neon" data-id="element-44" data-mp="1749tz4h49olc">
              {i + 1}
            </span>
            <div className="flex h-14 w-14 items-center justify-center rounded-full border border-[rgba(255,113,1,0.35)] bg-[rgba(255,113,1,0.08)]" data-id="element-45" data-mp="1l4uhgdxz88l6">
              <step.icon className="h-6 w-6 text-neon" aria-hidden="true" data-id="element-46" data-mp="2wi6ea4vbjqxu" />
            </div>
            <h3 className="mt-4 text-lg font-semibold text-white" data-id="element-47" data-mp="2rjd70u6mkw64">
              {t(step.title)}
            </h3>
            <p className="mt-2 text-sm text-silver/70" data-id="element-48" data-mp="1p6gpv1dij00j">{t(step.desc)}</p>
            {i < steps.length - 1 && <ArrowRightIcon className="absolute -right-2 top-1/2 hidden h-5 w-5 -translate-y-1/2 text-silver/30 lg:block" data-id="element-49" data-mp="1u48qcjs83ugc" />}
          </motion.div>)}
      </div>
    </section>;
}